import { Route } from 'react-router-dom';
import { CheatSheetRoute } from './CheatSheetRoute';
import { EnrollRoute } from './EnrollRoute';
import { ManageRoute } from './ManageRoute';
import { PATH } from './PATH';
import { MANAGE_FEATURES } from './manageFeatures';
import { RoleHomeRedirect } from './RoleHomeRedirect';
import { SecuredRoutes } from './SecuredRoutes';
import { SellerLoginRoute } from './SellerLoginRoute';
import { SellerRoute } from './SellerRoute';
import {
    ComingSoon,
    Dashboard,
    Enroll,
    NotFound,
    Seller,
    SellerLogin,
    Shifts,
    Transactions,
} from '@/pages';

export const AppRouter = (
    <Route>
        <Route element={<NotFound />} path={PATH.NOT_FOUND} />
        <Route element={<EnrollRoute />}>
            <Route element={<Enroll />} path={PATH.ENROLL} />
        </Route>
        {/* The seller path (sign-in and the sale screen) sits inside
            `CheatSheetRoute`, so `F1` opens the cheat sheet there only. */}
        <Route element={<SellerLoginRoute />}>
            <Route element={<CheatSheetRoute />}>
                <Route element={<SellerLogin />} path={PATH.LOGIN} />
            </Route>
        </Route>
        <Route element={<SecuredRoutes />}>
            <Route element={<RoleHomeRedirect />} path={PATH.HOME} />
            <Route element={<SellerRoute />}>
                <Route element={<CheatSheetRoute />}>
                    <Route element={<Seller />} path={PATH.SELLER} />
                </Route>
            </Route>
            {/* Admin app — the management area, inside the app shell. Each
                management feature is its own top-level route (one item, one
                route) rendered as a "coming soon" stub until it is built. */}
            <Route element={<ManageRoute />}>
                <Route element={<Dashboard />} path={PATH.MANAGE} />
                <Route element={<Transactions />} path={PATH.TRANSACTIONS} />
                <Route element={<Shifts />} path={PATH.SHIFTS} />
                {MANAGE_FEATURES.map((feature) => (
                    <Route
                        element={<ComingSoon />}
                        key={feature.slug}
                        path={feature.path}
                    />
                ))}
            </Route>
        </Route>
        <Route element={<NotFound />} path="*" />
    </Route>
);
